import { Input } from "@gearbox-protocol/deploy-tools-ui";
import type { ChangeEvent } from "react";
import { useCallback, useState } from "react";
import type {
  ControllerRenderProps,
  FieldPath,
  FieldValues,
} from "react-hook-form";

interface MultiInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> {
  field: ControllerRenderProps<TFieldValues, TName>;
  placeholder?: string;
  className?: string;
  separator?: string | RegExp;
}

const MultiInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>(
  props: MultiInputProps<TFieldValues, TName>,
) => {
  const { field, className, placeholder, separator = " " } = props;
  const { onChange, value } = field;
  const [state, setState] = useState(value?.join(" ") ?? "");

  const handleChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setState(e.target.value);
      const arr = e.target.value
        .split(separator)
        .map(s => s.trim())
        .filter(Boolean);
      return onChange(arr.length === 0 ? undefined : arr);
    },
    [onChange, separator],
  );

  return (
    <Input
      placeholder={placeholder}
      {...field}
      onChange={handleChange}
      value={state}
      className={className}
    />
  );
};

export default MultiInput;
